import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';
import { Spinner } from '@blueprintjs/core';
import Facets from '../facets';

const FiltersModal = (props) => {
  const { showModal, onClose, isFething } = props;
  return (
    <Modal show={showModal} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          <FormattedMessage id="filters.modal.title"/>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ padding: '0 15px' }}>
        <p className="m10-top">
          <strong>
            <FormattedMessage id="filters.modal.filterBy"/>:
          </strong>
        </p>
        {isFething ? <Spinner/> : <Facets {...props} collapsed={false}/>}
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onClose} disabled={isFething}>
          <FormattedMessage id="common.close"/>
        </Button>
      </Modal.Footer>
    </Modal>
  )
};

export default FiltersModal;



// WEBPACK FOOTER //
// ./src/views/recalls-list/side-bar/filters-modal.js